import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@pixi/react';
import { isMobile } from '../../../core/helpers/isMobile';
import { menuSectionStore } from '../../../store/menuSectionStore';
import MenuBackground from '../../../components/common/menu/menuBackground';
import MenuIcons from '../../../components/common/menu/menuIcons';
import CloseIcon from '../../../components/common/menu/closeIcon';
import { applicationStore } from '../../../store/applicationStore';

const MenuWrapper = observer(() => {
  const { isDemo } = applicationStore;
  const { isShowMenuPopup } = menuSectionStore;

  const { menuContainer, backGround, closeIcon, menuIcons } = useMemo(() => {
    return {
      menuContainer: {
        x: isMobile() ? 0 : 36,
        y: 0,
      },
      backGround: {
        x: isMobile() ? 270 : 0,
        y: isMobile() ? 926 : 405,
      },
      closeIcon: {
        y: isMobile() ? 52 : 48,
        x: isMobile() ? 500 : 0,
      },
      menuIcons: {
        x: isMobile() ? 69 : 0,
        y: isMobile() ? 926 : 157.5,
        margin: isMobile() ? (isDemo ? 195 : 140) : 70,
      },
    };
  }, [isDemo]);

  return (
    <Container
      visible={isShowMenuPopup}
      name='MenuContainer'
      x={menuContainer.x}
      y={menuContainer.y}
    >
      <MenuBackground x={backGround.x} y={backGround.y} />
      <CloseIcon x={closeIcon.x} y={closeIcon.y} />
      <MenuIcons x={menuIcons.x} y={menuIcons.y} margin={menuIcons.margin} />
    </Container>
  );
});
export default MenuWrapper;
